module.exports = {
    "es.whattodo": {
        agree: "Acepto las ",
        attention_24: "ATENCI\u00d3N 24H EN DESTINO",
        btn_blog: "Leer m\u00e1s",
        btn_product: "Comprar",
        btn_rent: "Alquilar",
        btn_send: "Enviar",
        btn_tours: "Reservar",
        contact_description: "Con\u00f3cenos un poco mejor.",
        contact_header:
            "Te acompa\u00f1aremos en esta magn\u00edfica experiencia \u00a1CON\u00d3CENOS!",
        dificult: "Dificultad",
        distance: "Distancia",
        email: "Email",
        equip: "Ropa deportiva",
        leader: "Gu\u00eda",
        live_valencia: "Vivir Valencia es f\u00e1cil, \u00a1CONT\u00c1CTANOS!",
        message: "Mensaje",
        name: "Nombre",
        privacity: "Politicas de privacidad",
        required: "Campo obligatorio",
        see_more: "Ver m\u00e1s",
        specification_tours: "Especificaciones",
        subject: "Asunto",
        success_send: "Envio correcto",
        success_send_message: "Su correo ha sido enviado.",
        swiming: "Se puede ba\u00f1ar",
        tours_description: "Descripci\u00f3n de la excursi\u00f3n.",
        tours_dificult: ["F\u00e1cil", "Medio", "Dificil"],
        tours_equip: ["S\u00ed", "No"],
        tours_icon: {
            dificult: "icon-trepar",
            distance: "icon-brujula",
            equip: "icon-deportista",
            swiming: "icon-nadador"
        },
        tours_price:
            'Dale click en "Reservar" para elegir la cantidad de personas que van a la excursi\u00f3n',
        tours_swiming: ["S\u00ed", "No"]
    },
    "en.whattodo": {
        agree: "I accept the ",
        attention_24: "ATTENTION 24H IN DESTINATION",
        btn_blog: "Read more",
        btn_product: "Buy",
        btn_rent: "Rent",
        btn_send: "Send",
        btn_tours: "Book",
        contact_description: "Get to know us a little better.",
        contact_header:
            "We accompany you in this magnificent experience, GET TO KNOW US",
        dificult: "Dificult",
        distance: "Distance",
        email: "Email",
        equip: "Sportswear",
        leader: "Guide",
        live_valencia: "Live Valencia is easy, contact us!",
        message: "Message",
        name: "Name",
        privacity: "Privacy policies",
        required: "Required field",
        see_more: "See more",
        specification_tours: "Specifications",
        subject: "Subject",
        success_send: "Successful send",
        success_send_message: "Your mail has been sent.",
        swiming: "You can swim",
        tours_description: "Tour description",
        tours_dificult: ["Easy", "Medium", "Hard"],
        tours_equip: ["Yes", "No"],
        tours_price:
            'Click on "Reserve" to choose the number of people who go to the tour',
        tours_swiming: ["Yes", "No"]
    },
    "fr.whattodo": {
        agree: "J'accepte les  ",
        attention_24: "ATTENTION 24H EN DESTINATION",
        btn_blog: "Lire la suite",
        btn_product: "Acheter",
        btn_rent: "Louer",
        btn_send: "Envoyer",
        btn_tours: "Réserve",
        contact_description: "Apprenez à nous connaître un peu mieux.",
        contact_header:
            "Nous vous accompagnons dans cette magnifique expérience, FAITES-NOUS CONNAÎTRE",
        dificult: "Difficile",
        distance: "Distance",
        email: "Email",
        equip: "Vêtements de sport",
        leader: "Guider",
        live_valencia: "Vivre Valence est facile, contactez-nous!",
        message: "Message",
        name: "Prénom",
        privacity: "Les politiques de confidentialité",
        required: "Champs requis",
        see_more: "Voir plus",
        specification_tours: "Caractéristiques",
        subject: "Assujettir",
        success_send: "Envoi réussi",
        success_send_message: "Votre mail a été envoyé.",
        swiming: "Tu peux nager",
        tours_description: "Description du tour",
        tours_dificult: ["Facile", "Moyen", "Difficile"],
        tours_equip: ["Oui", "Non"],
        tours_price:
            "Cliquez sur \"Réserver\" pour choisir le nombre de personnes qui vont à la tournée",
        tours_swiming: ["Oui", "Non"]
    }
};



// WEBPACK FOOTER //
// ./src/settings/Translations.js